module.exports = __webpack_public_path__ + "img/header.a83d548d.png";